export class Environment {
  public static production: true;
  public static baseUrl = 'https://api.bookmyloft.com';
  public static UrlPath =  Environment.baseUrl + '/api/v1';
  public static appId = '533117244284385';
  public static clientName = 'bookmyloft';
  public static clientPassword = 'LiQf@TP82c#Q';
}